// extracted by css-extract-rspack-plugin
export default {"pricing":"Zjp3ryjijdceeAnd","price":"tXEO6hi_vdgeG3pP","currency":"iEZ_7B7A7UFjaMvE","geoTax":"DflZ6qhsgh9VTJ2r"};